export default "__VITE_ASSET__3a25c6fb__"